var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    className: "st0",
    d: "M256.9,390.7c-15.5,23.6-9.4,55.9,14.8,71.4c23.6,15.5,55.9,9.4,71.3-14.8 c15.5-23.6,116.4-218.1,92.2-233.6C411.7,198.1,272.4,367.1,256.9,390.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    className: "st0",
    d: "M479,225.7c-11.1,9.7-12.4,26.5-2.7,37.7c37.2,42.7,57.8,97.5,57.9,154.1 c0,14.9,12,26.9,26.9,26.9c14.9,0,26.9-12,26.9-26.9c0,0,0,0,0,0c0-69.3-25.6-136.6-71.3-189.1C507.3,217.7,490.5,216.3,479,225.7z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    className: "st0",
    d: "M38.8,445.2c14.9,0,26.9-12.1,26.9-26.9C65.8,289,170.8,184,300,184c23.3,0,46.4,3.4,68.7,10.1 c14.3,4.2,29.4-4,33.6-18.3c4.2-14.2-3.9-29.2-18.1-33.5c-27.6-8.1-55.9-12.8-84.1-12.8c-158.9,0-288.1,129.2-288.1,288.1 C11.9,433.1,24,445.2,38.8,445.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.cfefb52f9475bb28bee4f17f89094181.svg";
export { ForwardRef as ReactComponent };